module.exports = __webpack_public_path__ + "img/sagam_electronic.8c25b61f.png";